import React from 'react';
import { ServiceLandingHero } from '../components/ServiceLandingHero';
import { ArrowRightIcon } from 'lucide-react';
import { commercialCarePage } from '../data/commercialCare';
export function CommercialLandscapeCarePage() {
  const {
    hero,
    audience,
    services,
    seasonal
  } = commercialCarePage;
  return <>
      {/* Service landing hero */}
      <ServiceLandingHero id="top" eyebrow={hero.eyebrow} title={hero.title} intro={hero.intro} image={hero.image} alt={hero.alt} tone="olive" data-id="element-503" data-mp="3fo3w49dnoxf3" />

      {/* Audience */}
      <section aria-labelledby="care-audience-title" className="section-y bg-ivory" data-id="element-504" data-mp="3tm250z97k1n7">
        <div className="site-container grid gap-10 lg:grid-cols-12 lg:gap-14" data-id="element-505" data-mp="2fhls1pe9y0q">
          <div className="lg:col-span-7" data-id="element-506" data-mp="2dejojaywefn">
            <h2 id="care-audience-title" className="section-title max-w-[640px] text-charcoal" data-id="element-507" data-mp="q4k3f9k13qv8">{audience.title}</h2>
            <p className="mt-5 max-w-[600px] text-[16px] leading-relaxed text-charcoal/75 sm:text-[17px]" data-id="element-508" data-mp="uwtwgygfx71q">{audience.text}</p>
          </div>
          <ul aria-label="Who we care for" className="border-t border-olive/30 lg:col-span-5 lg:self-end" data-id="element-509" data-mp="suqoxqkpm3i5">
            {audience.labels.map(label => <li key={label} className="border-b border-charcoal/15 py-4 font-display text-[24px] font-medium leading-snug text-olive lg:text-[26px]" data-id="element-510" data-mp="12npmhxy6p4dw">
                {label}
              </li>)}
          </ul>
        </div>
      </section>

      {/* Maintenance services */}
      <section aria-labelledby="care-services-title" className="section-y border-y border-charcoal/10 bg-stone/60" data-id="element-511" data-mp="16nzpd1qojeoj">
        <div className="site-container" data-id="element-512" data-mp="1lj5yvyozhvmm">
          <h2 id="care-services-title" className="section-title max-w-[720px] text-charcoal" data-id="element-513" data-mp="1gm5ppewu8cra">{services.title}</h2>

          <div className="mt-10 lg:mt-12" data-id="element-514" data-mp="3ndoid91yfn05">
            {services.groups.map(group => <section key={group.id} id={group.id} aria-labelledby={`${group.id}-title`} className="grid gap-4 border-t border-charcoal/15 py-7 md:grid-cols-12 md:gap-10 lg:py-8" data-id="element-515" data-mp="3ietwtzclrkcc">
                <h3 id={`${group.id}-title`} className="font-display text-[26px] font-medium leading-[1.15] text-charcoal md:col-span-4 lg:text-[30px]" data-id="element-516" data-mp="kxhwhmbsh0nz">
                  {group.title}
                </h3>
                <ul className="grid gap-x-10 sm:grid-cols-2 md:col-span-8 lg:grid-cols-3" data-id="element-517" data-mp="uv5s0eh7yc77">
                  {group.items.map(item => <li key={item} className="flex min-h-[44px] items-start gap-3 py-2.5 text-[16px] leading-[1.5] text-charcoal/85" data-id="element-518" data-mp="13nzn9ld29m6p">
                      <span className="mt-[10px] h-1 w-1 shrink-0 rounded-full bg-moss" aria-hidden="true" data-id="element-519" data-mp="1dm5m1u3kmc7c" />
                      <span data-id="element-520" data-mp="1ikgvw4tv8mpk">{item}</span>
                    </li>)}
                </ul>
              </section>)}
          </div>

          <p className="border-t border-charcoal/15 pt-7 text-[16px] leading-relaxed text-charcoal/75 md:max-w-[640px]" data-id="element-521" data-mp="330y62bh9zgg3">
            {services.note}
          </p>
        </div>
      </section>

      {/* Related seasonal support */}
      <section aria-labelledby="care-seasonal-title" className="bg-ivory py-12 md:py-16" data-id="element-522" data-mp="2o60evlxv4x0l">
        <div className="site-container" data-id="element-523" data-mp="3ltiungpxyze3">
          <div className="grid gap-5 border-l-2 border-olive pl-6 md:pl-8 lg:grid-cols-12 lg:items-center lg:gap-14 lg:pl-10" data-id="element-524" data-mp="3lshbeoyrv6la">
            <h2 id="care-seasonal-title" className="font-display text-[28px] font-medium leading-[1.12] text-charcoal sm:text-[32px] lg:col-span-4" data-id="element-525" data-mp="3gv7k13rtokut">
              {seasonal.title}
            </h2>
            <p className="max-w-[560px] text-[16px] leading-relaxed text-charcoal/75 lg:col-span-5" data-id="element-526" data-mp="8ecknya8hilh">{seasonal.text}</p>
            <a href={seasonal.link.href} className="focus-ring group inline-flex min-h-[44px] items-center gap-2 text-[15px] font-medium text-olive lg:col-span-3 lg:justify-self-end" data-id="element-527" data-mp="3nnoi5nlzxg0">
              <span className="border-b border-olive/35 pb-0.5 transition-colors duration-150 group-hover:border-olive" data-id="element-528" data-mp="3pby7mka86usb">
                {seasonal.link.label}
              </span>
              <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-0.5" strokeWidth={1.5} aria-hidden="true" data-id="element-529" data-mp="3fd8nekuuwy8w" />
            </a>
          </div>
        </div>
      </section>
    </>;
}